import { debounceTime, filter, takeUntil, tap, map } from 'rxjs/operators';

import {
  Component,
  OnInit,
  OnDestroy,
  EventEmitter,
  Output,
  Input,
  ChangeDetectorRef,
  SimpleChanges,
  OnChanges,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { ReplaySubject, Subject } from 'rxjs';
import { SummaryApiProviderService } from '@project/data-providers';
import { NotificationsService } from '@lib/notifications';
@Component({
  selector: 'app-cid-select',
  templateUrl: './cid-select.component.html',
  styleUrls: ['./cid-select.component.scss'],
})
export class CidSelectComponent implements OnInit, OnDestroy, OnChanges {
  @Output() setIsSearching = new EventEmitter<boolean>();
  @Output() onCidSelected = new EventEmitter<string>();

  @Input() selectedCid: any | null = null;
  @Input() disabled?: boolean = false;

  public isSearching = false;

  public serverSideCtrl: FormControl = new FormControl();
  public serverSideFilteringCtrl: FormControl = new FormControl();
  public filteredOptions: ReplaySubject<{ name: string; value: string }[]> = new ReplaySubject<any[]>(1);

  protected _onDestroy = new Subject<void>();

  constructor(
    private summaryApiProviderService: SummaryApiProviderService,
    private notificationsService: NotificationsService,
    private cdRef: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.serverSideFilteringCtrl.valueChanges
      .pipe(
        map((value: string) => {
          const reDots = /\./g;

          return value.replace(reDots, '').trim();
        }),
        filter((search) => !!search && search.length > 2),
        tap(() => {
          this.isSearching = true;
          this.setIsSearching.emit(true);
        }),
        takeUntil(this._onDestroy),
        debounceTime(500),
        map((search) => this.summaryApiProviderService.getCIDBySearch(search)),
      )
      .subscribe((filteredOptions) => {
        filteredOptions.subscribe(
          (cids) => {
            this.isSearching = false;
            this.setIsSearching.emit(false);

            const cidsOptions = cids.map((option) => ({
              name: `${option.code} - ${option.description}`,
              value: option.id,
            }));

            this.filteredOptions.next(cidsOptions);
          },
          () => {
            this.isSearching = false;
            this.setIsSearching.emit(false);
            this.notificationsService.error({ message: 'Falha ao buscar CID' });
          },
        );
      });

    this.attemptToAutoFillCid();
    this.handleCidSelectionChanges();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedCid'] && !changes['selectedCid'].firstChange) {
      const newCid = changes['selectedCid'].currentValue;

      if (!newCid || newCid.id === null) {
        this.serverSideCtrl.setValue(null, { emitEvent: false });
        this.serverSideFilteringCtrl.setValue('', { emitEvent: false });
        this.filteredOptions.next([]);
        this.cdRef.markForCheck();
      } else {
        this.attemptToAutoFillCid();
      }
    }
  }

  attemptToAutoFillCid(): void {
    if (!this.selectedCid) return;

    this.serverSideCtrl.setValue(this.selectedCid, { emitEvent: false });

    const cidNameSubstr = this.selectedCid?.name?.substring(0, 3);
    if (cidNameSubstr) this.serverSideFilteringCtrl.setValue(cidNameSubstr);

    this.filteredOptions.subscribe((options) => {
      const matchedOption = options.find((o) => o.value === (this.selectedCid?.value || this.selectedCid?.id));
      if (!matchedOption) return;

      this.serverSideCtrl.setValue(matchedOption);
      this.cdRef.detectChanges();
    });
  }

  handleCidSelectionChanges(): void {
    this.serverSideCtrl.valueChanges.subscribe((value) => {
      this.onCidSelected.emit(value);
    });
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}
